import { createClient } from "@supabase/supabase-js";
import { assertCurrentSupabaseDeploymentBoundary } from "./supabaseDeploymentBoundary";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

assertCurrentSupabaseDeploymentBoundary(supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
